


import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import CurrUserContext from '../contexts/CurrUserContext';
import { pageRouteUrls } from './pageRouteUrls';
import { clearAuthRecoveryFlag, tryRecoverAuth } from './authRecovery';

interface PrivateRouteProps {
  children: JSX.Element;
}

const IsAuthRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthorized } = useContext(CurrUserContext);

  if (isAuthorized()) {
    clearAuthRecoveryFlag();
    return children;
  }

  // Looks unauthorized — try one self-healing reload before trusting that
  // (see authRecovery.ts for why this read can be a false negative).
  if (tryRecoverAuth()) return null;

  return <Navigate to={pageRouteUrls.ErrorNotAuth()} replace />;
};

export default IsAuthRoute;
